import "./index.scss";

import { App } from "App";
import { ToastsProvider } from "providers";
import { TooltipsProvider } from "providers";
import { TranslationsProvider } from "providers";
import { PopoversProvider } from "providers";
import { AuthenticationProvider } from "providers";
import { StrictMode } from "react";
import { CookiesProvider } from "react-cookie";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

// register chart.js components
// Chart.register(ArcElement, Tooltip);

const element = document.getElementById("root") as Element;
const root = ReactDOM.createRoot(element);

root.render(
  <AuthenticationProvider>
    <StrictMode>
      <BrowserRouter>
        <CookiesProvider defaultSetOptions={{ path: "/" }}>
          <TranslationsProvider>
            <PopoversProvider>
              <TooltipsProvider>
                <ToastsProvider>
                  <App />
                </ToastsProvider>
              </TooltipsProvider>
            </PopoversProvider>
          </TranslationsProvider>
        </CookiesProvider>
      </BrowserRouter>
    </StrictMode>
  </AuthenticationProvider>
);
